import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id FF7E431E-FEA7-4953-AC5F-877269DE3B16
 * name arrow-u-right-bottom-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-right-bottom-bold.svg
 * tags
 */
export const ArrowURightBottomBoldIcon = createSvgIcon(<><path d="M10.5 3H18V7H10.5C8.57 7 7 8.57 7 10.5S8.57 14 10.5 14H13V10L20 16L13 22V18H10.5C6.36 18 3 14.64 3 10.5S6.36 3 10.5 3Z" /></>, 'ArrowURightBottomBoldIcon');
export default ArrowURightBottomBoldIcon